import React from "react";
import {Message, MultipleFieldErrors} from "react-hook-form";

export const required = {required: 'Campo obbligatorio.'};
export const userName = {required: 'Inserire il nome utente.'};
export const requiredNoMessage = {required: true}
export const minLen8 = {minLength: {value: 8, message: 'min 8'}};

export const numero = {
    /*pattern: {
        value: /^(0|[1-9]\d*)(\.\d+)?$/
    },*/
    valueAsNumber: true,
}
export const minNumber = (v: number) => ({...numero, min: {value: v, message: `Il numero dev'essere maggiore o uguale a ${v}`}});
export const maxNumber = (v: number) => ({...numero, max: {value: v, message: `Il numero dev'essere minore o uguale a ${v}`}});
export const email = {
    pattern: {
        value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        message: 'Utilizzare il formato email "user@esempio.it"'
    }
}
export const telefono = {
    pattern: {
        value: /^[0-9]{10,15}$/,
        message: 'Inserire solo numeri'
    },
    maxLength: {value: 15, message: 'Lunghezza massima 15 numeri'},
    minLength: {value: 10, message: 'Lunghezza minima 10 caratteri'},
}
export const emailRequired = {...required, ...email}

type ErrorMessageRender = (data: {
    message: Message;
    messages?: MultipleFieldErrors;
}) => React.ReactNode;
export const render: ErrorMessageRender = ({message}) => <p className="mt-2 text-rose-700">{message}</p>;
